import React from 'react';
import Notice from "../Notice";
import {useSelector} from "react-redux";


const SummaryLoader = (props) => {
    const summaryLoading = useSelector(state => state.summaryReducer.summaryLoading);
    const displayPatternSummary = useSelector(state => state.configuratorStateReducer.displayPatternSummary);
    const displayElementSummary = useSelector(state => state.configuratorStateReducer.displayElementSummary);
    const styles = {
        top : {
            width: '100%',
            height: '200px',
        },
        divider : {
            borderBottom: '2px solid #FEDB00',
            margin: '10px'
        },
        bottom : {
            width: '100%',
            height:' 40px'
        }

    }

    if(summaryLoading === 'pending' && !displayElementSummary && !displayPatternSummary) {
        return (
            <div className="summary-wrapper">
                <div className="summary" id="summary-panel">
                    <div className="panel">
                        <div className="row">
                            <div className="small-12 columns summary-title">
                                <h2>Summary - </h2>
                            </div>
                        </div>
                        <div className="row">
                            <Notice addPadding={true}/>
                            <div className="small-12 columns no-padding">
                                <div className={'loading-gradient'} style={styles.top}></div>
                                <div style={styles.divider}></div>
                                <div className={'loading-gradient'} style={styles.bottom}></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    } else {
        return null;
    }
}

export default SummaryLoader;